/**
 * This type matches the props for the TeamLinkIcon component in embeddable-directory
 */

/**
 * These names match the Provider Name in the JSON-LD response from respective resolvers
 */
export var ProviderNames = /*#__PURE__*/function (ProviderNames) {
  ProviderNames["CONFLUENCE"] = "Confluence";
  ProviderNames["JIRA"] = "Jira";
  return ProviderNames;
}({});